export default "__VITE_ASSET__Iynlb711__"